import { render, staticRenderFns } from "./EmailFormInput.vue?vue&type=template&id=23093eda&scoped=true&"
import script from "./EmailFormInput.vue?vue&type=script&lang=js&"
export * from "./EmailFormInput.vue?vue&type=script&lang=js&"
import style0 from "./EmailFormInput.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmailFormInput.vue?vue&type=style&index=1&id=23093eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23093eda",
  null
  
)

export default component.exports